import {paNumber} from './helpers/paNumber';
import {paIframeChild} from './paIframeChild';
// import importedData from './../json/data.json';

export const paData = {
    data: null,
    cache: false,
    init() {
        window.paData = this;
    },
    loaded() {
        return new Promise(
            function (resolve, reject) {
                if (typeof importedData != 'undefined') {
                    paData.data = importedData;
                    resolve(paData.data)
                } else {
                    paData.loadData().then(
                        function (dataLoadingResult) {
                            paData.data = dataLoadingResult;
                            resolve(paData.data)
                        }
                    );
                }
            });
    },
    loadData() {
        let suffix = '';
        if (!this.cache) {
            suffix = '?disable-cache=' + paNumber.random(0, 9999);
        }
        let uri = paIframeChild.libSource + 'data.json' + suffix;
        return this.getJson(uri);
    },
    getJson(uri) {
        return this.get(uri)
            .then(JSON.parse)
            .catch(function (error) {
                throw new ApplicationError(error)
            });
    },
    get(url) {
        return new Promise(function (resolve, reject) {
            let req = new XMLHttpRequest();
            req.open('GET', url);
            req.onload = function () {
                if (req.status === 200) {
                    resolve(req.response);
                } else {
                    reject(new Error(req.statusText));
                }
            };
            req.onerror = function () {
                reject(new Error('Network error'));
            };
            req.send();
        });
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/paData.js